module.exports = __webpack_public_path__ + "index.html";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[name].[ext]!./index.html
// module id = 9
// module chunks = 0